(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvResultDialogController', EnvResultDialogController);

    EnvResultDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'EnvResult', 'EnvOrder', 'EnvResultDet'];

    function EnvResultDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, EnvResult, EnvOrder, EnvResultDet) {
        var vm = this;

        vm.envResult = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.orders = EnvOrder.query({filter: 'result-is-null'});
        $q.all([vm.envResult.$promise, vm.orders.$promise]).then(function() {
            if (!vm.envResult.order || !vm.envResult.order.id) {
                return $q.reject();
            }
            return EnvOrder.get({id : vm.envResult.order.id}).$promise;
        }).then(function(order) {
            vm.orders.push(order);
        });
        vm.envresultdets = EnvResultDet.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.envResult.id !== null) {
                EnvResult.update(vm.envResult, onSaveSuccess, onSaveError);
            } else {
                EnvResult.save(vm.envResult, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:envResultUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dob = false;
        vm.datePickerOpenStatus.collectionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
